var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { Box, CircularProgress, FormControl, FormHelperText, Grid, MenuItem, Select, Stack, Typography, } from '@mui/material';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from '../../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { dynamicFileButtonSx, dynamicFileNameSx, dynamicHelperTextSx, FILE_ROW_SX, WIZARD_COLORS, } from '../../../components/FormComponents/dynamicForm';
import { deleteApplicationDocument, DOC_TYPE_REQUIRED_MESSAGE, FILE_UPLOAD_DOC_TYPES, FILE_UPLOAD_HINT, findDocTypeLabel, prepareDocumentFile, REMOVE_FAILED_MESSAGE, SUPPORTED_DOCUMENT_TYPES, uploadApplicationDocument, validateDocumentFile, } from '../document_upload_service';
import UploadedDocumentCard from './UploadedDocumentCard';
import constants from '../../../config/constants';
import { utility } from '../../../utils';
var NO_FILE_TEXT = 'No File Choosen, Yet.';
var FILE_NAME_PLACEHOLDER = 'File Name';
var DOC_TYPE_PLACEHOLDER = 'Document Type';
var WARNING_TITLE = 'Warning';
var UPLOAD_IN_FLIGHT_MESSAGE = 'Please wait for the document upload to finish.';
var NOT_UPLOADED_MESSAGE = 'Please upload the chosen file, or remove it, before continuing.';
var ROW_HEIGHT = '42px';
var FilesUploadPanel = React.forwardRef(function (_a, ref) {
    var _b;
    var uploadContext = _a.uploadContext, onDraftApplicationId = _a.onDraftApplicationId;
    var fileInputRef = React.useRef(null);
    var _c = React.useState(null), selectedFile = _c[0], setSelectedFile = _c[1];
    var _d = React.useState(''), docType = _d[0], setDocType = _d[1];
    var _e = React.useState(''), docTypeError = _e[0], setDocTypeError = _e[1];
    var _f = React.useState(''), fileError = _f[0], setFileError = _f[1];
    var _g = React.useState(false), isUploading = _g[0], setIsUploading = _g[1];
    var _h = React.useState([]), documents = _h[0], setDocuments = _h[1];
    var _j = React.useState(null), documentToRemove = _j[0], setDocumentToRemove = _j[1];
    var contextRef = React.useRef(uploadContext);
    contextRef.current = __assign(__assign({}, uploadContext), { applicationId: uploadContext.applicationId || contextRef.current.applicationId });
    React.useImperativeHandle(ref, function () { return ({
        validate: function () {
            if (isUploading) {
                utility.alert(UPLOAD_IN_FLIGHT_MESSAGE, constants.TOAST_TYPES.WARN);
                return false;
            }
            if (selectedFile && !docType) {
                setDocTypeError(DOC_TYPE_REQUIRED_MESSAGE);
                return false;
            }
            if (selectedFile) {
                utility.alert(NOT_UPLOADED_MESSAGE, constants.TOAST_TYPES.WARN);
                return false;
            }
            return true;
        },
        getDocuments: function () { return documents; },
    }); }, [docType, documents, isUploading, selectedFile]);
    var clearSelection = React.useCallback(function () {
        setSelectedFile(null);
        setDocType('');
        setDocTypeError('');
        setFileError('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }, []);
    var openFilePicker = React.useCallback(function () {
        var _a;
        if (!isUploading) {
            (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    }, [isUploading]);
    var handleFileChange = React.useCallback(function (event) {
        var _a;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file) {
            return;
        }
        var message = validateDocumentFile(file);
        setFileError(message);
        setDocTypeError('');
        setSelectedFile(file);
        setDocType('');
    }, []);
    var handleDocTypeChange = React.useCallback(function (event) {
        var _a;
        setDocType(String((_a = event.target.value) !== null && _a !== void 0 ? _a : ''));
        setDocTypeError('');
    }, []);
    var handleUpload = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var message, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedFile || isUploading) {
                        return [2];
                    }
                    if (!docType) {
                        setDocTypeError(DOC_TYPE_REQUIRED_MESSAGE);
                        return [2];
                    }
                    message = validateDocumentFile(selectedFile);
                    if (message) {
                        setFileError(message);
                        return [2];
                    }
                    setIsUploading(true);
                    return [4, uploadApplicationDocument(prepareDocumentFile(selectedFile, findDocTypeLabel(docType), documents), docType, contextRef.current)];
                case 1:
                    result = _a.sent();
                    setIsUploading(false);
                    if (!result.isSuccess || !result.document) {
                        utility.alert(result.message, constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (result.applicationId) {
                        contextRef.current = __assign(__assign({}, contextRef.current), { applicationId: result.applicationId });
                        onDraftApplicationId(result.applicationId);
                    }
                    setDocuments(function (previous) { return __spreadArray(__spreadArray([], previous, true), [result.document], false); });
                    clearSelection();
                    return [2];
            }
        });
    }); }, [clearSelection, docType, documents, isUploading, onDraftApplicationId, selectedFile]);
    var handleRemoveConfirmed = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var removed, isRemoved;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    removed = documentToRemove;
                    setDocumentToRemove(null);
                    if (!removed) {
                        return [2];
                    }
                    return [4, deleteApplicationDocument(removed.id)];
                case 1:
                    isRemoved = _a.sent();
                    if (!isRemoved) {
                        utility.alert(REMOVE_FAILED_MESSAGE, constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    setDocuments(function (previous) { return previous.filter(function (entry) { return entry.id !== removed.id; }); });
                    return [2];
            }
        });
    }); }, [documentToRemove]);
    var fileName = (_b = selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name) !== null && _b !== void 0 ? _b : '';
    return (React.createElement(Box, null,
        React.createElement(Stack, { direction: { xs: 'column', lg: 'row' }, alignItems: { xs: 'stretch', lg: 'flex-start' }, spacing: 1.5 },
            React.createElement(Box, { sx: __assign(__assign({}, FILE_ROW_SX), { flex: 1, minWidth: 0, cursor: isUploading ? 'default' : 'pointer' }), onClick: openFilePicker },
                React.createElement(Box, { component: "button", type: "button", disabled: isUploading, sx: __assign(__assign({}, dynamicFileButtonSx(isUploading)), { display: 'flex', alignItems: 'center', gap: 0.75, height: ROW_HEIGHT }) },
                    isUploading && (React.createElement(CircularProgress, { size: 13, sx: { color: 'inherit' } })),
                    isUploading ? 'Uploading…' : 'Choose File'),
                React.createElement(Box, { sx: __assign(__assign({}, dynamicFileNameSx(Boolean(fileName), Boolean(fileError))), { height: ROW_HEIGHT }) }, fileName || FILE_NAME_PLACEHOLDER)),
            Boolean(selectedFile) && (React.createElement(Stack, { direction: "row", alignItems: "flex-start", spacing: 1.5, sx: { width: { xs: '100%', lg: 'auto' } } },
                React.createElement(FormControl, { size: "small", error: Boolean(docTypeError), sx: { width: { xs: '100%', sm: 260, lg: 260 } } },
                    React.createElement(Select, { displayEmpty: true, value: docType, disabled: isUploading, onChange: handleDocTypeChange, inputProps: { 'aria-label': 'Document Type' }, sx: {
                            height: ROW_HEIGHT,
                            fontSize: 14,
                            borderRadius: '6px',
                            backgroundColor: WIZARD_COLORS.surface,
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: WIZARD_COLORS.border,
                            },
                        }, renderValue: function (selected) {
                            return selected ? (findDocTypeLabel(String(selected))) : (React.createElement(Box, { component: "span", sx: { color: WIZARD_COLORS.label } },
                                DOC_TYPE_PLACEHOLDER,
                                ' ',
                                React.createElement(Box, { component: "span", sx: { color: WIZARD_COLORS.error } }, "*")));
                        } }, FILE_UPLOAD_DOC_TYPES.map(function (option) { return (React.createElement(MenuItem, { key: option.value, value: option.value, sx: { fontSize: 14 } }, option.label)); })),
                    Boolean(docTypeError) && (React.createElement(FormHelperText, { sx: { marginLeft: 0, fontSize: 11 } }, docTypeError))),
                React.createElement(CustomButton, { variant: "contained", MDButton: true, fullWidth: false, bgColor: WIZARD_COLORS.ink, disabled: isUploading || Boolean(fileError), onClick: handleUpload, sx: { height: ROW_HEIGHT, minWidth: '120px', flexShrink: 0 } }, "Upload"),
                React.createElement(CustomButton, { variant: "outlined", MDButton: true, fullWidth: false, disabled: isUploading, onClick: clearSelection, sx: { height: ROW_HEIGHT, minWidth: '90px', flexShrink: 0 } }, "Clear")))),
        React.createElement("input", { ref: fileInputRef, type: "file", hidden: true, accept: SUPPORTED_DOCUMENT_TYPES, "aria-label": "Supporting Document", onChange: handleFileChange }),
        React.createElement(Typography, { sx: __assign(__assign({}, dynamicHelperTextSx), { color: fileError ? WIZARD_COLORS.error : WIZARD_COLORS.label }) }, FILE_UPLOAD_HINT),
        documents.length ? (React.createElement(Grid, { container: true, spacing: 2, alignItems: "stretch", sx: { marginTop: '10px' } }, documents.map(function (uploadedDocument) { return (React.createElement(Grid, { item: true, xs: 12, md: 6, key: uploadedDocument.id },
            React.createElement(UploadedDocumentCard, { uploadedDocument: uploadedDocument, onRemove: setDocumentToRemove }))); }))) : (React.createElement(Typography, { sx: { marginTop: '10px', fontSize: 13, color: WIZARD_COLORS.muted } }, NO_FILE_TEXT)),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.EVENT_NOT_ALLOWED, open: Boolean(fileError), titleText: WARNING_TITLE, message: fileError, acceptBtnText: "Ok", acceptCallBack: clearSelection }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, open: Boolean(documentToRemove), titleText: "Are you sure?", message: "This document will be removed from the application.", acceptBtnText: "Delete", acceptCallBack: handleRemoveConfirmed, denyBtnText: "Cancel", denyCallBack: function () { return setDocumentToRemove(null); }, cancelCallBack: function () { return setDocumentToRemove(null); } })));
});
FilesUploadPanel.displayName = 'FilesUploadPanel';
export default FilesUploadPanel;
